import { Routes, RouterModule } from '@angular/router';
import { ServicesSpecificationNamesAddComponent } from './services-specification-names/add/services-specification-names-add.component';
import { ServicesSpecificationNamesListComponent } from './services-specification-names/list/services-specification-names-list.component';
import { AutomationProcessesComponent } from './automation-proccesses/automation-proccesses.component';
import { TDRSCreationComponent } from './tdrs-creation/tdrs-creation.component';
import { AutomationComponent } from './automation.component';
import { ServicesSpecificationNamesEditComponent } from './services-specification-names/edit/services-specification-names-edit.component';
import { TDRSValidationComponent } from './tdrs-validation/tdrs-validation.component';
import { ExcelSheetsExamplesComponent } from './excel-sheets-examples/excel-sheets-examples.component';
import { AutomationAdministrationComponent } from './automation-administration/automation-administration.component';
import { UserInfoNilTransformation } from './userinfo-nil-transformation/userinfo-nil-transformation.component';

const routes: Routes = [
    {
        path: 'automation',
        component: AutomationComponent,
        children: [
            {
                path: '',
                component: ServicesSpecificationNamesListComponent
            }, {
                path: 'service-spec-name-add',
                component: ServicesSpecificationNamesAddComponent
            },
            {
                path: 'service-spec-name-edit/:id',
                component: ServicesSpecificationNamesEditComponent
            },
            {
                path: 'tdrs-creation',
                component: TDRSCreationComponent
            },
            {
                path: 'tdrs-validation',
                component: TDRSValidationComponent
            },
            {
                path: 'automation-proccesses-list',
                component: AutomationProcessesComponent
            },
            {
                path: 'excel-sheets-examples',
                component: ExcelSheetsExamplesComponent
            }, 
            {
                path: 'automation-administration',
                component: AutomationAdministrationComponent
            },
            {
                path: 'userinfo-nil-transformation',
                component: UserInfoNilTransformation
            }
        ]
    }
];


export const AUTOMATION_ROUTER_PROVIDER = RouterModule.forRoot(routes, { useHash: false });


// WEBPACK FOOTER //
// ./src/app/automation/automation.routes.ts